export default values => ({
  economicActivities: values.economicActivities && values.economicActivities.length
    ? values.economicActivities
    : [{ id: '', name: '', percentage: '' }]
});
